
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/content/magazine",
      function () {
        return require("private-next-pages/content/magazine/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/content/magazine"])
      });
    }
  